import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function cartId() {
  let id = localStorage.getItem("om_cart");
  if (!id) {
    const a = new Uint8Array(12);
    crypto.getRandomValues(a);
    id = "guest_" + Array.from(a, (b) => b.toString(16).padStart(2, "0")).join("");
    localStorage.setItem("om_cart", id);
  }
  return id;
}

export const api = axios.create({ baseURL: API, withCredentials: true });
let csrf = null;
api.interceptors.request.use((c) => {
  c.headers["X-Cart-Id"] = cartId();
  if (csrf) c.headers["X-CSRF-Token"] = csrf;
  return c;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => {
    if (r.data?.csrf_token) csrf = r.data.csrf_token;
    return r;
  },
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 403 && /CSRF/.test(err.response?.data?.detail || "") && !cfg._csrf) {
      cfg._csrf = true;
      try {
        await api.get("/auth/csrf");
        return api(cfg);
      } catch {
        return Promise.reject(err);
      }
    }
    if (err.response?.status === 401 && !cfg._retry && (!cfg.url?.startsWith("/auth/") || cfg.url === "/auth/me")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => (refreshing = null));
      try {
        await refreshing;
        return api(cfg);
      } catch {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Une erreur est survenue.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d.map((x) => {
      if (!x || typeof x.msg !== "string") return JSON.stringify(x);
      if (/email/i.test(x.msg) || x.loc?.includes("email")) return "Adresse courriel invalide.";
      if (x.type === "missing") return "Un champ obligatoire est manquant.";
      if (x.type?.startsWith("string_too_short")) return "Un champ est trop court.";
      return x.msg.replace(/^Value error, /, "");
    }).join(" ");
  }
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
}

export function money(v, currency = "CAD", lang = "fr") {
  if (v == null || isNaN(v)) return "—";
  return new Intl.NumberFormat(lang === "en" ? "en-CA" : "fr-CA", { style: "currency", currency }).format(v);
}

export const pct = (v, d = 1) => (v == null ? "—" : `${(v * 100).toFixed(d)} %`);
export const dt = (s) => (s ? new Date(s).toLocaleString("fr-CA", { dateStyle: "short", timeStyle: "short" }) : "—");
export const fileUrl = (u, w) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}${w && u.startsWith("/api/files/") ? `?w=${w}` : ""}` : u);

export function track(type, extra = {}) {
  try {
    const c = JSON.parse(localStorage.getItem("om_consent") || "{}");
    if (!c.analytics) return;
    let sid = sessionStorage.getItem("om_sid");
    if (!sid) {
      sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem("om_sid", sid);
    }
    api.post("/events", { type, session_id: sid, ...extra }).catch(() => {});
  } catch {
    /* no-op */
  }
}
